import { Button, Typography } from '@themenu/design-system'
import { BoxSection } from 'components'
import Head from 'next/head'
import Link from 'next/link'

export default function Page404() {
  return (
    <>
      <Head>
        <title>Swile - Página não encontrada</title>
      </Head>

      <BoxSection padding={32} gap={32}>
        <div className="flex flex-col items-center justify-center">
          <div className="relative flex mt-40">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="88"
              height="88"
              viewBox="0 0 88 88"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M44 0C13.2 0 0 11 0 44C0 77 13.2 88 44 88C74.8 88 88 77 88 44C88 11 74.8 0 44 0Z"
                fill="url(#paint0_linear_2932_395661)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_2932_395661"
                  x1="-32.0829"
                  y1="-27.5"
                  x2="88"
                  y2="88"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#CE55B0" />
                  <stop offset="0.406196" stopColor="#F34DAC" />
                  <stop offset="0.870571" stopColor="#F48E66" />
                </linearGradient>
              </defs>
            </svg>

            <div className="absolute mt-[18px] ml-[22px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="49"
                viewBox="0 0 44 49"
                fill="none"
              >
                <path
                  d="M18.25 27H25.75M17.0002 17V19.5M27 17V19.5M2 45.0065C2 45.9946 2.9775 46.6348 3.81 46.1965L8.6675 43.6147L14.775 46.8605C15.1275 47.0465 15.54 47.0465 15.8925 46.8605L22 43.6147L28.1075 46.8579C28.46 47.0438 28.8725 47.0438 29.225 46.8579L35.3325 43.612L40.19 46.1938C41.0225 46.6348 42 45.9946 42 45.0065V34.5C42 15.4967 42 2 22 2C1.99999 2 2 15.4967 2 34.5L2 45.0065Z"
                  stroke="white"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
          <div className="flex mt-40">
            <Typography variant="h1" gradientColor="pink">
              404&nbsp;
            </Typography>
            <Typography variant="h1" className="text-content-subdued">
              página não encontrada!
            </Typography>
          </div>

          <Typography variant="body" mt={40} className="text-content-default">
            Desculpe, não pudemos encontrar a página que você esta procurando.
          </Typography>

          <Link href="/">
            <Button endIcon="home" mt={40} mb={40}>
              Me Leve para a home
            </Button>
          </Link>
        </div>
      </BoxSection>
    </>
  )
}
